import { Routes } from '@angular/router';
import { mainAppRoutes } from './app.main.routes';

export const routes: Routes = mainAppRoutes;
